import { registerKeapFormElement } from './keap-forms-processing';
import { registerKeapEventElements, registerKeapHostingElement } from '@/hosting/keap-track';
import { processKeapLinks } from '@/hosting/keap-links';
import { processCalendly } from '@/hosting/calendly-appointments';
import mountIslands from '@/hosting/ssr/mountIslands';

window.addEventListener('load', async () => {
    try {
        await mountIslands();
    } catch (e) {
        console.error(e);
    }

    registerKeapHostingElement();
    registerKeapFormElement();
    registerKeapEventElements();
    processKeapLinks();
    processCalendly();
});
